import Typography from '@material-ui/core/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import SearchBox from '../../SearchBox/SearchBox';
import { withRouter } from 'react-router-dom';
import { GREY_700, GREY_900, WHITE } from 'assets/theme/colors';
import { Image, Container } from 'react-bootstrap';
import { Box, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import {
  CONNECT_INFO_CARD,
  EXPLORE_INFO_CARD,
  MAIN_TABLET_BACKGROUND_URL,
  PARTNER_LOGO,
  PLANE_INFO_CARD,
  some,
} from '../../../../constants/constants';

const ImageBox = styled.div`
  position: relative;
  background-size: cover;
`;
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${MAIN_TABLET_BACKGROUND_URL})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    margin: 0,
    color: GREY_900,
  },
  copyrightFooter: {
    color: GREY_700,
    position: 'fixed',
    bottom: '6px',
    marginLeft: '100px',
  },
}));

interface Props {
  results: some;
  getBookerInfo: () => void;
}

const SearchBookerMain_Tablet: React.FC<Props> = (props) => {
  const { results, getBookerInfo } = props;
  const classes = useStyles();
  return (
    <Container className={classes.root}>
      <Grid container direction="column" justify="center" alignItems="center">
        <div style={{ marginTop: '50px', marginLeft: '148px' }}>
          <ImageBox>
            <Image src={`${PARTNER_LOGO}`} fluid alt="tripi partner logo" />
          </ImageBox>
          <Typography variant="h4" style={{ marginTop: '70px' }}>
            <FormattedMessage id="home.searchGate" />
          </Typography>
          <Typography variant="h4" style={{ marginBottom: '12px' }}>
            <FormattedMessage id="home.BookerInfo" />
          </Typography>
          <Typography
            variant="body2"
            style={{
              maxWidth: '60%',
              marginBottom: '24px',
              paddingLeft: '10px',
            }}
          >
            <FormattedMessage id="home.AboutBookerSearch" />
          </Typography>
          <Box>
            <SearchBox results={results} onSearch={getBookerInfo} />
          </Box>
        </div>

        <Grid item container direction="row" style={{ color: WHITE }}>
          <Grid item sm={6} md>
            <Box
              style={{
                position: 'relative',
                left: '90px',
                right: '90px',
              }}
            >
              <Image src={`${PLANE_INFO_CARD}`} fluid alt="Plane Card" />
              <Typography
                variant="h6"
                style={{ position: 'absolute', top: '300px', left: '50px' }}
              >
                Tripi Partner là gì?
              </Typography>
              <Typography
                variant="subtitle2"
                style={{
                  position: 'absolute',
                  top: '340px',
                  left: '50px',
                  maxWidth: '300px',
                }}
              >
                Tripi Partner là nền tảng công nghệ kinh doanh du lịch thuộc
                Tripi - thành viên của VNTravel Group, tập đoàn đứng đầu Đông
                Nam Á về du lịch trực tuyến. Đây cũng là 1 trong 4 trụ cột chính
                của VnLife, công ty FinTech Tỉ đô sở hữu “kỳ lân” VNPay.
              </Typography>
            </Box>
          </Grid>
          <Grid item sm={6} md>
            <Box
              style={{
                position: 'relative',
                top: '80px',
              }}
            >
              <Image src={`${EXPLORE_INFO_CARD}`} fluid alt="Explore Card" />
              <Typography
                variant="h6"
                style={{ position: 'absolute', top: '340px', left: '30px' }}
              >
                Hướng đi tiên phong
              </Typography>
              <Typography
                variant="subtitle2"
                style={{
                  position: 'absolute',
                  top: '380px',
                  left: '30px',
                  maxWidth: '300px',
                }}
              >
                Tripi Partner tự hào là giải pháp tiên phong tại Việt Nam giúp
                đối tác đại lý kinh doanh du lịch nhanh chóng – hiệu quả - tối
                ưu lợi nhuận thông qua ứng dụng gọn nhẹ và tiện lợi.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Grid container style={{ color: WHITE }}>
          <Grid item sm={12} md>
            <Box style={{ position: 'relative', left: '150px' }}>
              <Image src={`${CONNECT_INFO_CARD}`} fluid alt="Connect Card" />
              <Typography
                variant="h6"
                style={{
                  position: 'absolute',
                  top: '200px',
                  left: '50px',
                  maxWidth: '200px',
                }}
              >
                Mọi lúc mọi nơi trong một ứng dụng
              </Typography>
              <Typography
                variant="subtitle2"
                style={{
                  position: 'absolute',
                  top: '270px',
                  left: '50px',
                  maxWidth: '300px',
                }}
              >
                Đối tác dễ dàng thực hiện mọi thao tác từ tìm kiếm nhà cung cấp,
                bán hàng, quản lý đơn hàng, quản lý doanh thu, chăm sóc khách
                hàng v..v và được hỗ trợ 24/7 ngay trên chiếc điện thoại di động
                để sẵn sàng kinh doanh du lịch mọi lúc - mọi nơi.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <div className={classes.copyrightFooter}>
        <p>Copyright © 2020 VNTRAVEL.,JSC</p>
      </div>
    </Container>
  );
};

export default withRouter(SearchBookerMain_Tablet);
